import { createAction, createReducer } from '@reduxjs/toolkit';
import { ofType } from 'redux-observable';
import { debounceTime, tap } from 'rxjs';
export const NO_ACTION = createAction('NO_ACTION')();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getStoreConfig(storeConfigs) {
    return storeConfigs.reduce((storesConfig, config) => (Object.assign(Object.assign({}, storesConfig), { [config.featureKey]: getReducer(config.initialState, config.reducers) })), {});
}
function getReducer(initialState, reducers) {
    return createReducer(initialState, (builder) => reducers.forEach(([action, reducerFn]) => builder.addCase(action.type, reducerFn)));
}
export function getEffect(action, operatorFn, startAction, endAction) {
    const actionTypes = (Array.isArray(action) ? action : [action]).map(({ type }) => type);
    let actionId = '';
    return (actions$, state$) => actions$.pipe(ofType(actionTypes[0], ...actionTypes.slice(1)), tap((action) => (actionId = action.type)), tap(() => startAction(actionId)), operatorFn(state$), debounceTime(300), tap(() => endAction(actionId)));
}
